import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

//DSS Documentation on ApiResult - http://tiny.sc/cgapiresult
import { ApiResult } from '@soco/core';
//DSS Documentation on SocoHttpService - http://tiny.sc/cgSocoHttpService
import { SocoHttpService } from '@soco/http';

import { Sample } from './sample';

@Injectable({
    providedIn: 'root'
})
export class SampleService {
    private baseUrl = 'Sample';

    constructor(
        private http: SocoHttpService
    ) { }

    /**
     *  Retrieves all samples
     *  @param alertId If an error occurs and you want to use an alert other than the default alert, specify the alert id
     */
    getAll(alertId?: string): Observable<ApiResult<Sample[]>> {
        //DSS Documentation on SocoHttpService - http://tiny.sc/cgSocoHttpService
        //DSS Documentation on handling exceptions - http://tiny.sc/cgclientexceptions
        return this.http.get<Sample[]>({
            url: this.baseUrl,
            alertId: alertId
        });
    }

    /**
     *  Retrieves the specified sample
     *  @param id The id of the sample to be retrieved
     *  @param alertId If an error occurs and you want to use an alert other than the default alert, specify the alert id
     */
    getById(id: number, alertId?: string): Observable<ApiResult<Sample>> {
        //DSS Documentation on SocoHttpService - http://tiny.sc/cgSocoHttpService
        //DSS Documentation on handling exceptions - http://tiny.sc/cgclientexceptions
        return this.http.get<Sample>({
            url: this.baseUrl + '/GetById',
            params: { id: id },
            alertId: alertId
        });
    }

    /**
     *  Adds a new sample
     *  @param sample The sample to be added
     *  @param alertId If an error occurs and you want to use an alert other than the default alert, specify the alert id
     */
    add(sample: Sample, alertId?: string): Observable<ApiResult<Sample>> {
        //DSS Documentation on SocoHttpService - http://tiny.sc/cgSocoHttpService
        //DSS Documentation on handling exceptions - http://tiny.sc/cgclientexceptions
        //DSS Documentation on Validation - http://tiny.sc/cgvalidation
        return this.http.post<Sample>({
            url: this.baseUrl,
            data: sample,
            alertId: alertId,
            shouldIgnoreInvalidResult: true,
            pleaseWaitTimeoutDuration: 500
        });
    }

    /**
     *  Updates the specified sample
     *  @param sample The sample to be updated
     *  @param alertId If an error occurs and you want to use an alert other than the default alert, specify the alert id
     */
    update(sample: Sample, alertId?: string): Observable<ApiResult<Sample>> {
        //DSS Documentation on SocoHttpService - http://tiny.sc/cgSocoHttpService
        //DSS Documentation on handling exceptions - http://tiny.sc/cgclientexceptions
        //DSS Documentation on Validation - http://tiny.sc/cgvalidation
        return this.http.put<Sample>({
            url: this.baseUrl,
            data: sample,
            alertId: alertId,
            shouldIgnoreInvalidResult: true,
            pleaseWaitTimeoutDuration: 500
        });
    }

    /**
     *  Deletes the specified sample
     *  @param id The id of the sample to be deleted
     *  @param alertId If an error occurs and you want to use an alert other than the default alert, specify the alert id
     */
    del(id: number, alertId?: string): Observable<ApiResult<Sample>> {
        //DSS Documentation on SocoHttpService - http://tiny.sc/cgSocoHttpService
        //DSS Documentation on handling exceptions - http://tiny.sc/cgclientexceptions
        //DSS Documentation on Validation - http://tiny.sc/cgvalidation
        return this.http.del<Sample>({
            url: this.baseUrl,
            params: { id: id },
            alertId: alertId,
            pleaseWaitTimeoutDuration: 500
        });
    }
}
